import { render, staticRenderFns } from "./Dashboard_Mobile.vue?vue&type=template&id=71f65319&scoped=true&"
import script from "./Dashboard_Mobile.vue?vue&type=script&lang=js&"
export * from "./Dashboard_Mobile.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_Mobile.vue?vue&type=style&index=0&id=71f65319&prod&lang=css&"
import style1 from "./Dashboard_Mobile.vue?vue&type=style&index=1&id=71f65319&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f65319",
  null
  
)

export default component.exports